export default "__VITE_ASSET__CjIvMhRL__"